import { useCallback } from 'react';
import PropTypes from 'prop-types';
import ChevronDownIcon from '@untitled-ui/icons-react/build/esm/ChevronDown';
import { Button, Checkbox, FormControlLabel, Menu, MenuItem, SvgIcon } from '@mui/material';
import { usePopover } from 'src/hooks/use-popover';
import {filterCurrentWeek, filterSingleDay, filterWeek} from "../pages/Home/FilterInfoOverview";
import useAuth from "../hooks/useAuth";

export const SingleSelect = (props) => {
  const { label, onChange, options, changeCallBack, value = [], ...other } = props;
  const popover = usePopover();
    const {filter} = useAuth();

    const handleValueChange = useCallback((event) => {
    if (changeCallBack) {
      changeCallBack(event.target.value);
    }
  }, [onChange, value]);

  return (
    <>
      <Button
        color="inherit"
        endIcon={(
          <SvgIcon>
            <ChevronDownIcon />
          </SvgIcon>
        )}
        onClick={popover.handleOpen}
        ref={popover.anchorRef}
        {...other}>
        {label}
      </Button>
      <Menu
        anchorEl={popover.anchorRef.current}
        onClose={popover.handleClose}
        open={popover.open}
        PaperProps={{ style: { width: 250 } }}
      >
        {options.map((option) => (
          <MenuItem key={option.label}>
            <FormControlLabel
              control={(
                <Checkbox
                  checked={value && option.value === value}
                  onChange={handleValueChange}
                  // disabled={option.value !== filterWeek && option.value !== filterSingleDay}
                  value={option.value}
                />
              )}
              label={option.label}
              sx={{
                flexGrow: 1,
                mr: 0
              }}
            />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

